import React from 'react'
import Parse from 'parse'
import Config from './config'
import {
  Redirect
} from 'react-router-dom'
import BrandLogo from './BrandLogoComponent'
import ThemeToggle from './ThemeToggleComponent'

export default class LoginForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      history: this.props.history
    }
  }

  handleEnvironmentChange = (event) => {
    Config.setEnvironment(event.target.value)
    window.location.reload(false)
  }

  handleSubmitClick = (e) => {
    e.preventDefault()
    console.log('handle submit click')

    const history = this.state.history

    Parse.User.logIn(this.state.email, this.state.password).then(async function (user) {
      console.log('Signed in!')
      const roleQuery = new Parse.Query(Parse.Role)
      roleQuery.equalTo('name', 'Admin')
      const role = await roleQuery.first()
      const adminUserQuery = role.get('users').query()
      const users = await adminUserQuery.find()
      const userIds = users.map((user) => { return user.id })
      if (!userIds.includes(user.id)) {
        console.log('Unauthorized')
        await Parse.User.logOut()
      } else {
        history.push('/')
      }
    }, function (error) {
      alert('Login failed: ' + error.message)
    })
  }

  handleEmailTextFieldChange = (event) => {
    this.setState({
      email: event.target.value
    })
  }

  handlePasswordTextFieldChange = (event) => {
    this.setState({
      password: event.target.value
    })
  }

  render = () => {
    if (this.state.redirect) {
      return <Redirect push to="/" />
    }
    const isDev = Config.getEnvironment() === 'dev'
    return (
      <div className="msp-login">
        <div className="msp-login-theme">
          <ThemeToggle />
        </div>
        <form id="loginform" className="msp-login-card" onSubmit={this.handleSubmitClick}>
          <BrandLogo className="msp-login-logo" />
          <h1 className="msp-login-title">Sign in to Admin</h1>
          <p className="msp-login-subtitle">Use your @myswimpro.com account.</p>
          <div className="mb-3">
            <label className="form-label" htmlFor="email">Email</label>
            <input type="email" className="form-control" id="email" placeholder="you@myswimpro.com" autoComplete="username" onChange={this.handleEmailTextFieldChange} />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="password">Password</label>
            <input type="password" className="form-control" id="password" placeholder="Password" autoComplete="current-password" onChange={this.handlePasswordTextFieldChange} />
          </div>
          <button type="submit" className="btn btn-primary w-100">Sign in</button>
          <div className="msp-login-footer">
            <label htmlFor="login-environment">Database</label>
            <select id="login-environment" className="form-select form-select-sm" value={isDev ? 'dev' : 'prod'} onChange={this.handleEnvironmentChange}>
              <option value="prod">Production</option>
              <option value="dev">🧪 Development</option>
            </select>
          </div>
        </form>
      </div>
    )
  }
}
